import { Component, OnInit, ViewChild } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AdminInquiryService } from '../shared/service/admin-inquiry.service';
import { Inquiry } from '../shared/model/Inquiry';
import { Router } from '@angular/router';
import { AutoLogoutService } from '../shared/service/auto-logout.service';
const LOCAL_USER_KEY = "UserName";
const STORE_KEY = 'lastAction';
@Component({
  selector: 'app-admin-inquiry',
  templateUrl: './admin-inquiry.component.html',
  styleUrls: ['./admin-inquiry.component.css']
})
export class AdminInquiryComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['FirstName', 'LastName', 'Email', 'Mobile', 'TravelDate', 'TravelDuration', 'TravelDestination', 'City', 'Status', 'Edit', 'Delete'];
  dataSource: any;
  @BlockUI() blockUI: NgBlockUI;
  inquiryArr = [];
  inquiryObj: Inquiry;
  LocalToken: string = '';
  constructor(private adminInquiryService: AdminInquiryService, private router: Router, private autoLogoutService: AutoLogoutService) {
    localStorage.setItem(STORE_KEY, Date.now().toString());
    this.autoLogoutService.check();
    this.autoLogoutService.initListener();
    this.autoLogoutService.initInterval();
  }

  ngOnInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getInquiry();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }

  }

  getInquiry() {
    this.adminInquiryService
      .getInquiry()
      .then((result) => {
        this.inquiryArr = result;
        this.dataSource = new MatTableDataSource();
        this.dataSource = new MatTableDataSource(this.inquiryArr);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      })
      .catch((err) => console.log(err));
  }

  editInquiry(inquiryObj) {
    if (inquiryObj) {
      this.inquiryObj = inquiryObj;
      if (this.inquiryArr.length > 0) {
        if (confirm('Inquiry will be closed. Are you sure?')) {
          this.inquiryObj.Status = 'Completed';
          this.adminInquiryService
            .editInquiry(inquiryObj)
            .then((result) => this.getInquiry())
            .catch((err) => console.log(err));
        }
      }
    }

  }

  deleteInquiry(ID) {
    if (this.inquiryArr.length > 0) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.adminInquiryService
          .deleteInquiry(ID)
          .then((result) => this.getInquiry())
          .catch((err) => console.log(err));
      }
    }
  }

  applyInquiryFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

}
